import { isIOS, isAndroid, isMobile } from 'react-device-detect'
import { APP_HELPER, LocalStorageService, CONSTANTS } from '../../../utils'

function ucFirst(string) {
	var val = ''
	if (!isEmpty(string)) {
		val = string.charAt(0).toUpperCase() + string.slice(1)
	}
	return val
}

function titleCase(str) {
	if (isNotEmpty(str)) {
		return str
			.toLowerCase()
			.split(/([ /!@#$%^&*()-,])/)
			.map(function (word) {
				return word.charAt(0).toUpperCase() + word.slice(1)
			})
			.join('')
	}
}

function ucWords(string) {
	var val = ''
	if (!isEmpty(string)) {
		val = string.toUpperCase()
	}
	return val
}

function parseToFloat(value, digit) {
	var digits
	if (!isEmpty(value)) {
		digits = parseFloat(value).toFixed(parseInt(digit))
	} else {
		digits = 'PKR 00'
	}
	return digits
}

function stringToBoolean(string) {
	switch (string) {
		case 'true':
		case 'yes':
		case '1':
		case 1:
			return true
		case 'false':
		case 'no':
		case '0':
		case 0:
		case null:
			return false
		default:
			return Boolean(string)
	}
}

function isNotEmpty(x) {
	return !isEmpty(x)
}

function isEmpty(x) {
	return (
		// typeof x === {} ||
		// typeof x === [] ||
		typeof x === undefined ||
		typeof x === 'undefined' ||
		x === null ||
		x === 'null' ||
		x === 'undefined' ||
		x === false ||
		x.length === 0 ||
		(x === 'object' && Object.key(x).length === 0) ||
		x === ''
	)
}

function wordCount(text) {
	return text.split(' ').length
}

function findInJson(object, value) {
	var record = object.filter(function (data) {
		return data.id === value
	})
	return record[0]
}

function groupByKey(array, key) {
	return array.reduce((hash, obj) => {
		if (obj[key] === undefined) return hash
		return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
	}, {})
}

function addObjectToCollection(obj, arr = []) {
	// append object
	arr.push(obj)
	return arr
}

/**
 *
 * HEADER SETTINGS
 *
 */

function setFavicon(icon) {
	;(function () {
		var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
		link.type = 'image/png,image/jpg,image/x-icon'
		link.rel = 'icon'
		link.href = icon
		document.getElementsByTagName('head')[0].appendChild(link)
	})()
}

/**
 *
 * LOCAL STORAGE SETTINGS
 *
 */

function findPropValInLocalStorage(key, propVal) {
	let localStorageVal = LocalStorageService._getFromLocalStorage(key)
	return isEmpty(localStorageVal) ? propVal : localStorageVal
}

/**
 *
 * REDIRECTION SETTINGS
 *
 */

function REDIRECT_TO_PATH(path) {
	LocalStorageService._clearLocalStorage()
	LocalStorageService._clearSessionStorage()
	if (window.opener !== null) {
		// window.onunload = null;
		window.onbeforeunload = null
	}
	window.location.href = path
}

/**
 *
 * FORMAT SETTINGS
 *
 */
function thousands_separators(num) {
	var num_parts = num.toString().split('.')
	num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	return num_parts.join('.')
}

function formatPrice(currency, charges, roundOff = true) {
	let charge = !HELPER.isEmpty(charges) && charges !== '' ? parseFloat(charges) : 0
	let roundOffCharge = roundOff ? charge : charge
	// let roundOffCharge = roundOff ? charge.toFixed(2) : charge;
	const storageLocale = APP_HELPER.APP_LOCALE()
	if (storageLocale === CONSTANTS.IS_ENGLISH || HELPER.isEmpty(storageLocale)) {
		return {
			charges: thousands_separators(roundOffCharge),
			currency,
			default: currency + ' ' + thousands_separators(roundOffCharge),
		}
	} else {
		return {
			charges: thousands_separators(roundOffCharge),
			currency,
			default: thousands_separators(roundOffCharge) + ' ' + currency,
		}
	}
}

function hideShowFooter(show = false) {
	if (isMobile) {
		const element = document.getElementsByClassName('footerWrap')
		if (show) {
			element[0].classList.add('footer-transition')
		} else {
			element[0].classList.remove('footer-transition')
		}
	}
}

const sendEventToAndroid = (functionType) => {
	return isAndroid && window.Android && functionType in window.Android
}

const sendEventToiOS = (functionType) => {
	return (
		isIOS &&
		!HELPER.isEmpty(window.webkit) &&
		!HELPER.isEmpty(window.webkit.messageHandlers) &&
		functionType in window.webkit.messageHandlers
	)
}

function getTextFromString(htmlString) {
	return (
		document
			.createRange()
			// Creates a fragment and turns the supplied string into HTML nodes
			.createContextualFragment(htmlString)
			// Gets the text from the fragment
			.textContent // Removes the Zero-Width Space, Zero-Width Joiner, Zero-Width No-Break Space, Left-To-Right Mark, and Right-To-Left Mark characters
			.replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, '')
			// Trims off any extra space on either end of the string
			.trim()
	)
}

function groupByList(list, keyGetter) {
	const map = new Map()
	list.forEach((item) => {
		const key = keyGetter(item)
		const collection = map.get(key)
		if (!collection) {
			map.set(key, [item])
		} else {
			collection.push(item)
		}
	})
	return map
}

function isScrolledIntoView(el) {
	if (el) {
		var rect = el.getBoundingClientRect()
		var elemTop = rect.top
		var elemBottom = rect.bottom

		// Only completely visible elements return true:
		var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight
		// Partially visible elements return true:
		//isVisible = elemTop < window.innerHeight && elemBottom >= 0;
		return isVisible
	}
}

const HELPER = {
	groupByList,
	getTextFromString,
	// GENERAL SETTINGS
	ucFirst,
	ucWords,
	parseToFloat,
	stringToBoolean,
	isNotEmpty,
	isEmpty,
	wordCount,
	findInJson,
	addObjectToCollection,
	groupByKey,

	// HEADER SETTINGS
	setFavicon,

	//LOCAL STORAGE SETTINGS
	findPropValInLocalStorage,

	//REDIRECTION SETTINGS
	REDIRECT_TO_PATH,

	//FORMAT SETTINGS
	formatPrice,
	hideShowFooter,

	sendEventToAndroid,
	sendEventToiOS,
	titleCase,
	isScrolledIntoView,
}
export default HELPER
